import React from 'react';
import EdgeDevices from './EdgeDevices';
import DeviceStatus from './DeviceStatus';
import InbndOutbndCalls from './InbndOutbndCalls';
import UsageByLineType from './UsageByLineType';
import LineTypeDispersement from './LineTypeDispersement';
import CallTraffic from './CallTraffic';
import TotalCallsByDay from './TotalCallsByDay';
import Usage from './Usage';
import axios from 'axios';

const styles = { containerDiv: { paddingBottom: '15px' } };

function DashboardAnalytics() {
  const [analyticsData, setAnalyticsData] = React.useState(null);
  const [isLoadingAnalyticsData, setIsLoadingAnalyticsData] = React.useState(true);
  const [analyticsError, setAnalyticsError] = React.useState(null);

  React.useEffect(() => {
    let ignore = false;
    const abortController = new AbortController();

    async function fetchData() {
      try {
        setIsLoadingAnalyticsData(true);

        const token = localStorage.getItem('jwtToken');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};

        const url = `${process.env.REACT_APP_BASE_URL}/apps/api/analytics/dashboard`;

        const { data } = await axios.get(url, {
          headers,
          signal: abortController.signal,
        });

        if (!ignore) {
          setAnalyticsData(data);
        }
      } catch (error) {
        if (!ignore && !axios.isCancel(error) && error.name !== 'AbortError') {
          console.error('Failed to fetch dashboard analytics:', error);
          setAnalyticsError(error);
        }
      } finally {
        if (!ignore) {
          setIsLoadingAnalyticsData(false);
        }
      }
    }

    fetchData();

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, []);

  const { agg1, agg2, agg3, agg4, boxDetails } = analyticsData || {};

  if (analyticsError) {
    return (
      <div className="alert alert-danger" role="alert">
        Failed to load dashboard analytics data. Please try again later.
      </div>
    );
  }

  return (
    <div style={styles.containerDiv}>
      <div className="row">
        <div className="col-md-4 pr-2">
          <EdgeDevices isLoading={isLoadingAnalyticsData} count={boxDetails?.totalBoxes} />
        </div>
        <div className="col-md-4 pl-2 pr-2">
          <DeviceStatus
            isLoading={isLoadingAnalyticsData}
            registered={boxDetails?.registeredBoxes}
            unregistered={boxDetails?.unRegisteredBoxes}
            unmonitored={boxDetails?.unMonitoredBoxes}
          />
        </div>
        <div className="col-md-4 pl-2">
          <InbndOutbndCalls isLoading={isLoadingAnalyticsData} data={agg3} />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-4 pr-2">
          <LineTypeDispersement isLoading={isLoadingAnalyticsData} data={agg4} />
        </div>
        <div className="col-md-8 pl-2">
          <UsageByLineType isLoading={isLoadingAnalyticsData} data={agg1} />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-4 pr-2">
          <CallTraffic isLoading={isLoadingAnalyticsData} data={agg1} />
        </div>
        <div className="col-md-4 pl-2 pr-2">
          <TotalCallsByDay isLoading={isLoadingAnalyticsData} data={agg1} />
        </div>
        <div className="col-md-4 pl-2">
          <Usage isLoading={isLoadingAnalyticsData} data={agg2} />
        </div>
      </div>
    </div>
  );
}

export default DashboardAnalytics;
